<crud-list class="col-12" [data]="table" detailUrl="/enaio-learn/admin/user/" restUrl="api/lrn/learninguserflat" [allowDelete]=false [allowCreate]=false>
</crud-list>
